"use client";

import dynamic from "next/dynamic";
import { StyledButton } from "./Button.styles";
import { CircularProgress } from "@mui/material";
const Tooltip = dynamic(() => import("@mui/material/Tooltip"));
import PropTypes from "prop-types";

const Button = ({
  children,
  onClick,
  onSubmit,
  fullWidth = true,
  disabled,
  tooltip,
  loading = false,
  ...rest
}) => {
  const ParentEl = tooltip
    ? ({ children }) => (
        <Tooltip title={tooltip} arrow followCursor>
          <span>{children}</span>
        </Tooltip>
      )
    : ({ children }) => children;

  return (
    <ParentEl>
      <StyledButton
        onClick={onClick}
        onSubmit={onSubmit}
        fullWidth={fullWidth}
        disabled={disabled}
        {...rest}
      >
        {!loading ? (
          children
        ) : (
          <CircularProgress size={25} sx={{ color: "white" }} />
        )}
      </StyledButton>
    </ParentEl>
  );
};

Button.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
  onClick: PropTypes.func,
  onSubmit: PropTypes.func,
  fullWidth: PropTypes.bool,
  disabled: PropTypes.bool,
  tooltip: PropTypes.string,
  loading: PropTypes.bool,
};

export default Button;
